import { render } from "./Chatbox.vue?vue&type=template&id=0754b605&scoped=true"
import script from "./Chatbox.vue?vue&type=script&lang=js"
export * from "./Chatbox.vue?vue&type=script&lang=js"

import "./Chatbox.vue?vue&type=style&index=0&id=0754b605&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0754b605"]])

export default __exports__